import { Shield, Phone, BadgeCheck, Star, Lock, AlertCircle } from 'lucide-react';
import { Card } from '@/components/ui/card';
import { SecurityBanner } from '@/components/SecurityBanner';
import { TrustBadge } from '@/components/TrustBadge';

export default function TrustPage() {
  return (
    <div className="max-w-4xl mx-auto px-4 md:px-6 py-10 space-y-6">
      <div className="text-center">
        <Shield size={48} className="mx-auto text-[#1677F2]" />
        <h1 className="text-3xl md:text-4xl font-bold mt-2">Confiance & sécurité</h1>
        <p className="text-slate-600 mt-2">Nous mettons la confiance au cœur de Job Kongo. <span className="font-semibold">Mosala na confiance.</span></p>
      </div>

      <SecurityBanner />

      <Card className="p-6">
        <h2 className="text-xl font-bold mb-3">Nos 3 niveaux de vérification</h2>
        <div className="space-y-3">
          <div className="flex items-start gap-3">
            <TrustBadge type="phone" withLabel={false} />
            <div>
              <p className="font-semibold">Niveau 1 — Téléphone vérifié</p>
              <p className="text-sm text-slate-600">Code SMS pour confirmer l&apos;identité numérique.</p>
            </div>
          </div>
          <div className="flex items-start gap-3">
            <TrustBadge type="id" withLabel={false} />
            <div>
              <p className="font-semibold">Niveau 2 — Identité vérifiée</p>
              <p className="text-sm text-slate-600">Pièce officielle (carte d&apos;électeur, passeport, permis) + selfie. Validation manuelle.</p>
            </div>
          </div>
          <div className="flex items-start gap-3">
            <TrustBadge type="trusted" withLabel={false} />
            <div>
              <p className="font-semibold">Niveau 3 — Jobeur de confiance</p>
              <p className="text-sm text-slate-600">Au moins 5 jobs réalisés et note ≥ 4/5. Badge or.</p>
            </div>
          </div>
        </div>
      </Card>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Card className="p-5">
          <Lock className="text-[#16764A]" size={22} />
          <h3 className="font-semibold mt-2">Paiement en séquestre</h3>
          <p className="text-sm text-slate-600 mt-1">Vos fonds sont bloqués chez Job Kongo jusqu&apos;à la fin de la prestation. Aucun jobeur ne peut les toucher avant votre validation.</p>
        </Card>
        <Card className="p-5">
          <Star className="text-[#C9A800]" size={22} />
          <h3 className="font-semibold mt-2">Avis vérifiés</h3>
          <p className="text-sm text-slate-600 mt-1">Seuls les clients ayant finalisé un job peuvent noter. Les fausses recommandations sont impossibles.</p>
        </Card>
        <Card className="p-5">
          <AlertCircle className="text-[#CE1021]" size={22} />
          <h3 className="font-semibold mt-2">Bouton d&apos;urgence</h3>
          <p className="text-sm text-slate-600 mt-1">Dans chaque conversation, un bouton d&apos;alerte pour signaler un problème grave à notre équipe.</p>
        </Card>
        <Card className="p-5">
          <BadgeCheck className="text-[#0F5FCC]" size={22} />
          <h3 className="font-semibold mt-2">Médiation Job Kongo</h3>
          <p className="text-sm text-slate-600 mt-1">En cas de litige, notre équipe arbitre et peut rembourser via le fonds d&apos;assurance.</p>
        </Card>
      </div>

      <Card className="p-6 bg-[#FFE1E4] border-[#CE1021]/30">
        <h2 className="text-xl font-bold text-[#A10B18]">Paiement interdit en dehors</h2>
        <p className="text-sm text-slate-700 mt-2">Pour votre sécurité et celle de la communauté, tous les paiements doivent passer par Job Kongo. Payer en dehors (espèces, Mobile Money direct, etc.) entraîne :</p>
        <ul className="text-sm mt-2 list-disc list-inside space-y-1 text-slate-800">
          <li>Exclusion définitive de la plateforme (jobeur et client)</li>
          <li>Perte d&apos;assurance et d&apos;assistance</li>
          <li>Signalement aux autres utilisateurs</li>
        </ul>
      </Card>
    </div>
  );
}
